<template>
  <div class="columns">
    <div class="column">
      <a-select
        :manual-doc="userDoc"
        field="routes.failureNodes.where.failure.operator"
        :label="$t('operators.sg')"
        options="operators"
        null-option
        @change="(value) => updateAndFetch('failure.operator', value, true)"
      />

      <a-select
        :manual-doc="userDoc"
        field="routes.failureNodes.where.part.supplier"
        :label="$t('suppliers.ref.name')"
        options="suppliers"
        null-option
        @change="(value) => updateAndFetch('part.supplier', value, true)"
      />

      <a-select
        :manual-doc="userDoc"
        field="routes.failureNodes.where.part"
        :label="$t('parts.ref.name')"
        :options="supplierParts"
        null-option
        @change="(value) => updateAndFetch('part', value, true)"
      />

      <a-select
        :manual-doc="userDoc"
        field="routes.failureNodes.where.failure.type"
        :label="$t('failures.ref.type')"
        :options="keys(failureTypes)"
        :labels="failureTypes"
        null-option
        @change="(value) => updateAndFetch('failure.type', value, true)"
      />

      <simple-taginput
        :manual-doc="userDoc"
        field="routes.failureNodes.where.state"
        :label="$t('common.state')"
        :options="$store.getters['failureNodes/fields'].state.options"
        labels="failureNodes.options.state"
        null-option
        @change="(value) => updateAndFetch('state', value, true)"
      />

      <a-simple-datepicker
        :manual-doc="userDoc"
        field="routes.failureNodes.where.failure.progress.reported.at_gte"
        :label="$t('common.from')"
        @change="(value) => updateAndFetch('failure.progress.reported.at_gte', value, true)"
      />
    </div>

    <div class="column">
      <a-input
        :manual-doc="userDoc"
        field="routes.failureNodes.where.number_array"
        :label="$t('common.number')"
        update-on-click
        @change="updateNumber"
      />
    </div>
  </div>
</template>

<script>
import { keys, startsWith } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import SimpleTaginput from '@/components/SimpleTaginput'
import ASimpleDatepicker from '@/components/Form/ASimpleDatepicker'


export default {
  components: {
    SimpleTaginput,
    ASimpleDatepicker
  },
  computed: {
    ...mapGetters({
      parts: 'parts/items',
      suppliers: 'suppliers/items'
    }),
    process() {
      return process
    },
    userDoc () {
      return { module: 'user' }
    },
    where () {
      return this.user.routes.failureNodes.where
    },
    supplierParts() {
      if(this.where && this.where.part && this.where.part.supplier && this.where.part.supplier.id) {
        return this.parts.filter(item => item.supplier && item.supplier.id && (item.supplier.id === this.where.part.supplier.id))
      }
      return this.parts
    },
    failureTypes() {
      return {
        'guarantee': this.$t('failures.options.type.guarantee'),
        'post guarantee': this.$t('failures.options.type.post_guarantee')
      }
    }
  },
  created () {
    this.$store.dispatch('parts/fetchAll')
  },
  methods: {
    keys,
    async updateAndFetch (prop, value, fetch = false) {
      if(this.where.number_array) {
        await this.$store.dispatch('user/update', {
          path: `routes.failureNodes.where.number_array`,
          value: null
        })
      }

      if(startsWith(prop,'part')) {
        await this.$store.dispatch('user/update', {
          path: `routes.failureNodes.where.part`,
          value: null
        })
      }

      await this.$store.dispatch('user/update', {
        path: `routes.failureNodes.where.${prop}`,
        value
      })
      if(fetch) {
        this.$store.dispatch('failureNodes/fetchDocs')
      }
    },
    async updateNumber (value) {
      await this.$store.dispatch('failureNodes/resetFilters')
      this.updateAndFetch('number_array', value, true)
    }
  }
}
</script>
